import React from "react";
import "./persuasions.scss";
import { Time, Shield, Badge, People } from "../../../icons";

const Persuasions: React.FC = () => {
  const items = [
    {
      title: "Solidność",
      description: "Dbamy o każdy, nawet najmniejszy szczegół wykończenia.",
      icon: <Shield />,
    },
    {
      title: "Terminowość",
      description: "Gwarantujemy realizację prac w ściśle określonym czasie.",
      icon: <Time />,
    },
    {
      title: "Wysoka jakość",
      description: "Korzystamy wyłącznie ze sprawdzonych materiałów premium.",
      icon: <Badge />,
    },
    {
      title: "Indywidualne podejście",
      description: "Projektujemy i wykonujemy wnętrza uszyte na miarę.",
      icon: <People />,
    },
  ];

  return (
    <section className="persuasions">
      <div className="persuasions__header">
        <span className="persuasions__header-line"></span>
        <h2 className="persuasions__title">DLACZEGO MY?</h2>
        <span className="persuasions__header-line"></span>
      </div>

      <div className="persuasions__grid">
        {items.map((item, index) => (
          <div key={index} className="persuasions__card">
            <div className="persuasions__icon">{item.icon}</div>
            <h3 className="persuasions__card-title">{item.title}</h3>
            <p className="persuasions__card-description">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Persuasions;
